import { render } from "./AppChipBase.vue?vue&type=template&id=3ecbce16&scoped=true&ts=true"
import script from "./AppChipBase.vue?vue&type=script&lang=ts"
export * from "./AppChipBase.vue?vue&type=script&lang=ts"

import "./AppChipBase.vue?vue&type=style&index=0&id=3ecbce16&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ecbce16"]])

export default __exports__